<template>
  <div>
    <div class="row" v-if="!isNotFount">
      <div class="col-xl-5 col-lg-4">
        <fare-group-details/>
      </div>
      <div class="col-xl-7 col-lg-8">
        <operators-table :fare-group-id="getFareGroupId()" hide-fare-group-column/>
      </div>
      <div class="col-12">
        <fares-table :fare-group-id="getFareGroupId()" editable/>
      </div>
    </div>
    <div class="row align-content-center" v-else>
      NOT FOUND
    </div>
  </div>
</template>
<script>
  import FareGroupDetails from "./FareGroupDetails";
  import OperatorsTable from "src/pages/Operators/OperatorsTable.vue";
  import FaresTable from "src/pages/Fares/FaresTable";
  import {mapState} from "vuex";

  export default {
    name: 'fare-group',
    components: {
      FareGroupDetails,
      OperatorsTable,
      FaresTable
    },
    methods: {
      getFareGroupId() {
        return this.$route.params.id
      }
    },
    computed: {
      ...mapState({
        error: state => state.fare_group.error,
      }),
      isNotFount() {
        return this.error ? this.error.status == 404 : false;
      }
    },

  };
</script>
